<section class="login-area">
  <div class="row m-0">
    <div class="col-lg-7 col-md-12 col-12 p-0">
      <div class="login-image">
        <img alt="image" src="assets/img/login.png">
      </div>
    </div>

    <div class="col-lg-5 col-md-12 p-0">
      <div class="login-content">
        <div class="d-table">
          <div class="d-table-cell">
            <div class="login-form">
              <div class="logo">
                <a routerLink="/"><img alt="image" src="assets/img/black-logo.png"></a>
              </div>

              <h3 *ngIf="authType === 'login'">Добро пожаловать</h3>
              <p *ngIf="authType === 'login'">Вы входите впервые? <a
                routerLink="/student/register">Зарегистрироваться</a></p>
              <h3 *ngIf="authType == 'register'">Откройте свою учетную запись Secom</h3>
              <p *ngIf="authType == 'register'">Вы уже зарегистрированы? <a routerLink="/student/login">Войти</a></p>

              <form [ngClass]="{'enterCode': codeSent}" onsubmit="return false">
                <div *ngIf="authType === 'register'" class="form-group">
                  <input [(ngModel)]="currentUser.name" class="form-control" id="name" name="name" placeholder="Имя"
                         type="text">
                </div>

                <div *ngIf="authType === 'register'" class="form-group">
                  <input [(ngModel)]="currentUser.surname" class="form-control" id="surname" name="surname"
                         placeholder="Фамилия" type="text">
                </div>

                <div class="form-group" style="display: flex;">
                  <span class="form-control flag"> <img src="assets/flag.png"> +996</span>
                  <input [(ngModel)]="phoneNumber.phone" class="form-control" maxlength="9" minlength="9"
                         name="tel" placeholder="778010101" type="tel">
                </div>

                <div class="form-group">
                  <div id="recaptcha-container" style="padding:0.75rem;"></div>
                </div>
                <div *ngIf="userIsRegisteredModal">
                  <h6 style="color: red;">Аккаунт уже существует <a (click)="userIsRegisteredModal = false"
                                                                    routerLink='/student/login'>Войти</a>
                  </h6>
                </div>
                <div *ngIf="accountAlreadyExists">
                  <h6 style="color: red;">Пользователь не существует <a (click)="accountAlreadyExists = false"
                                                                        routerLink='/student/register'>Зарегистрироваться</a>
                  </h6>
                </div>
                <div *ngIf="authType === 'register'">
                  <button (click)="register()">
                    <span *ngIf="!checkIsUserRegistered && !sendingVerificationCode">Зарегистрироваться</span>
                    <span *ngIf="checkIsUserRegistered && !sendingVerificationCode">Проверка базы данных</span>
                    <span *ngIf="!checkIsUserRegistered && sendingVerificationCode">Код отправляется</span>
                    <i *ngIf="checkIsUserRegistered || sendingVerificationCode" class="fa fa-spinner fa-spin fa-lg"></i>
                  </button>
                </div>

                <div *ngIf="authType === 'login'">
                  <button (click)="login()">
                    <span *ngIf="!checkIsUserRegistered && !sendingVerificationCode">Войти</span>
                    <span *ngIf="checkIsUserRegistered && !sendingVerificationCode">Проверка базы данных</span>
                    <span *ngIf="!checkIsUserRegistered && sendingVerificationCode">Код отправляется</span>
                    <i *ngIf="checkIsUserRegistered || sendingVerificationCode" class="fa fa-spinner fa-spin fa-lg"></i>
                  </button>
                </div>
              </form>

              <form [ngClass]="{'checkCode': codeSent}" onsubmit="return false" style="display: none;">
                <p class="text-center">Пожалуйста, введите 6-значный код подтверждения</p>
                <div class="form-group" style="display: flex;">
                  <span class="form-control flag"> Код</span>
                  <input [(ngModel)]="verificationCode" class="form-control" maxlength="6" minlength="6" name="tel"
                         placeholder="" type="tel">
                </div>
                <h5 *ngIf="incorrectCode" class="text-danger font-weight-bold">Неверный код</h5>

                <div *ngIf="authType === 'register'" class="form-group">
                  <button (click)="verifyRegisterCode()" type="submit">
                    <span *ngIf="!codeVerifying && !accountCreated">Подтвердить</span>
                    <span *ngIf="codeVerifying && !creatingAccount">Подверждения кода </span>
                    <span *ngIf="!codeVerifying && creatingAccount">Создание аккунта</span>
                    <!--                    <span *ngIf="!codeVerifying && !creatingAccount" >Аккунт создано успешно</span>-->
                    <i *ngIf="accountCreated" class="fa fa-check fa-lg" style="color: green;"></i>
                    <i *ngIf="codeVerifying && !accountCreated" class="fa fa-spinner fa-spin fa-lg"></i></button>
                </div>
                <div *ngIf="authType === 'login'" class="form-group">
                  <button (click)="verifyLoginCode()" type="submit">
                    <span *ngIf="!codeVerifying">Подтвердить</span>
                    <span *ngIf="codeVerifying">Подверждения кода </span>
                    <i *ngIf="accountCreated" class="fa fa-check fa-lg" style="color: green;"></i>
                    <i *ngIf="codeVerifying && !accountCreated" class="fa fa-spinner fa-spin fa-lg"></i></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
